import { FunctionComponent, ReactElement, useState } from "react";

export type BooleanSwitcherChildrenProps = {
    /** Callback nastaví vnitřní stav na pravdu */
    turnOn: () => void;
    /** Callback nastaví vnitřní stav na nepravdu */
    turnOff: () => void;
    /** Hodnota vnitřního stavu */
    value: boolean;
};

export type BooleanSwitcherProps = {
    /** Potomci, kteří mají k dispozici vnitřní stav a callbacks pro jeho nastavní */
    children: (props: BooleanSwitcherChildrenProps) => ReactElement;
};

/** Komponenta slouží pro zachování, aktualizaci a poskytnutí logické hodnoty technikou `render props` */
export const BooleanSwitcher: FunctionComponent<BooleanSwitcherProps> = ({ children }) => {
    const [value, setValue] = useState<boolean>(false);

    const turnOn = () => setValue(true);

    const turnOff = () => setValue(false);

    return children({ turnOn, turnOff, value });
};
